// CR 媒體輪播

import { MEDIA_INFO } from "../common/constant";
import CRMediaItem from "./CRMediaItem";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from 'swiper/modules';
import '../../../styles/swipers.scss'; // 輪播樣式

const CRMediaSwiperWrap = () =>{
    return(
        <Swiper
            id="media-swiper"
            className="content-wrap w-full media-content-wrap flex asm:[&>.swiper-wrapper]:flex usm:pointer-events-auto"
            loop={true}
            pagination={{ clickable: true }}
            modules={[ Autoplay, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            centeredSlides={true} // 居中顯示當前 slide
            direction={'horizontal'} // 水平方向
            autoplay={{
                delay: 4000,
            }}
        >
            {Object.values(MEDIA_INFO).map((item,i)=>
                <SwiperSlide
                    key={`media-item-${i}`}
                    className="media-item w-full h-[300px] bg-yellow text-jblack flex-shrink-0 usm:h-full pr-[20px] usm:px-[5px]"
                >
                    <CRMediaItem
                        key={`section_content_item_${i}`}
                        info={item}
                    />
                </SwiperSlide>
            )}
        </Swiper>
    )
}

export default CRMediaSwiperWrap;